import React, { useRef } from "react";
import "./style.scss";
import { Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import { useState } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import sections from "./sections";
import LogoBig from "../../assets/LogoBig";
import { useSelector } from "react-redux";
import FinishSectionLoading from "./sections/FinishSectionLoading";
import FinishSectionSuccess from "./sections/FinishSectionSuccess";

function getSection(slug, availableSections = sections) {
	const index = availableSections.findIndex(section => section.slug === slug);
	return index !== -1 ? [index + 1, availableSections[index]] : [null, null];
}

function getNextSection(slug, availableSections = sections) {
	const index = availableSections.findIndex(section => section.slug === slug);
	return availableSections[index + 1] ? [index + 2, availableSections[index + 1]] : [null, null];
}

function getPreviousSection(slug, availableSections = sections) {
	const index = availableSections.findIndex(section => section.slug === slug);
	return availableSections[index - 1] ? [index - 2, availableSections[index - 1]] : [null, null];
}

function calculateErrors(values, availableSections = sections) {
	const errors = {};
	availableSections.forEach(section => {
		if (section.validate) {
			const result = section.validate({ values });
			errors[section.slug] = typeof result === "string" ?
				result : null;
		} else {
			errors[section.slug] = null;
		}
	});
	return errors;
}

export default function VendorOnboarding() {

	const canvas = useRef(null);
	// const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const tWrapper = useRef(null);
	const { user } = useSelector(state => ({
		user: state.session.user
	}));

	// The values for each section.
	const [values, setValues] = useState({});
	// The errors for each section, calculating the initial errors on load.
	const [errors, setErrors] = useState(calculateErrors(values));

	return <div className="vendorOnboarding">
		<div className="overlay" />
		<div className="logoBar">
			<LogoBig
				crossColor="#000000"
				fontColor="#ffffff"
				style={{
					width: 120,
					display: "inline-block"
				}}
			/>
		</div>
		<canvas ref={canvas} className="confetti-canvas" />
		<div className="transition-wrapper" ref={tWrapper}>
			<TransitionGroup >
				<CSSTransition
					key={location.pathname}
					classNames="form-section-change"
					onEntering={e => {
						if (tWrapper.current) {
							tWrapper.current.style.overflowY = "hidden";
							tWrapper.current.scrollTop = 0;
						}
					}}
					onEntered={e => {
						if (tWrapper.current)
							tWrapper.current.style.overflowY = "auto";
					}}
					timeout={500}
				>
					<Switch location={location}>

						{/* The finish stage where the shop is created. */}
						<Route path="/signup/finish/loading" render={router => (
							<FinishSectionLoading values={values} />
						)} />

						{/* The finish showing a success message and next steps. */}
						<Route path="/signup/finish/success" render={router => (
							<FinishSectionSuccess canvas={canvas} />
						)} />

						{/* Paginated form sections */}
						<Route path="/signup/:slug" render={({ match }) => {
							// Pull the section slug out of the URL.
							const { slug } = match.params;
							// Send them back to the start if there isn't a user.
							if (!user && slug !== sections[0].slug)
								return <Redirect to={`/signup/${sections[0].slug}`} />
							// Likewise if their current user has a shop.
							if (user && user.shop && slug !== sections[0].slug)
								return <Redirect to={`/signup/${sections[0].slug}`} />
							// Get the section for that slug.
							const [number, section] = getSection(slug);
							if (!section) return <Redirect to={`/signup/${sections[0].slug}`} />
							// And the actual rendered component.
							const FormSection = section.Component;

							// Get a reference for the next section if there is one.
							const [, nextSection] = getNextSection(slug);
							// Likewise for previous.
							const [, previousSection] = getPreviousSection(slug);

							// And render the current section.
							return <FormSection
								number={number}
								values={{ ...values }}
								buttons={section.buttons}
								error={errors[section.slug]}
								onChange={changes => {
									const newValues = { ...values, ...changes };
									setValues(newValues);
									setErrors(calculateErrors(newValues));
								}}
								onBack={previousSection ? () => {
									history.push(`/signup/${previousSection.slug}`);
								} : null}
								onNext={nextSection ? () => {
									history.push(`/signup/${nextSection.slug}`);
								} : null}
								onComplete={!nextSection ? () => {
									history.push(`/signup/finish/loading`);
								} : null}
							/>

						}} />

						{/* Catch-all to redirect back to form start */}
						<Route path="/signup" render={router => (
							<Redirect to={`/signup/${sections[0].slug}`} />
						)} />

					</Switch>
				</CSSTransition>
			</TransitionGroup>
		</div>
	</div>
}
